import { render } from "./FeaturesPageTwo.vue?vue&type=template&id=708f3a65"
import script from "./FeaturesPageTwo.vue?vue&type=script&lang=js"
export * from "./FeaturesPageTwo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\digitaldistribution.io-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__